import { create } from "zustand";

import { UserDTO } from "types";

interface UserStore {
  user: UserDTO;
  setUser: (user: UserDTO) => void;
  clearUser: () => void;
}

export const useUserStore = create<UserStore>((set) => ({
  user: {} as UserDTO,
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: {} as UserDTO }),
}));
